import { AcceptIssueStatus, CockpitStatus } from '@/utils/type';
import { request } from '../core';
import { Method } from '../core/util';

export default class CockpitManageApi {
  /**
   * 获取驾舱团队下坐席列表信息
   * @param param0
   * @returns
   */
  getCockpitListInfo = ({
    cockpitTeamNumber,
    vehicleName,
    cockpitNumber,
  }: {
    cockpitTeamNumber: string;
    vehicleName: string | null;
    cockpitNumber: string | null;
  }): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/k2/management/monitor/cockpit_team/get_cockpit_list_info',
      method: Method.POST,
      body: { cockpitTeamNumber, vehicleName, cockpitNumber },
    };
    return request(requestParams);
  };

  /**
   * 获取驾驶团队下车辆信息
   * @param param0
   * @returns
   */
  getTeamVehicleInfo = ({
    cockpitTeamNumber,
  }: {
    cockpitTeamNumber: string;
  }): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/k2/management/monitor/cockpit_team/get_device_info',
      method: Method.POST,
      body: { cockpitTeamNumber, stationBaseIdList: [], vehicleName: null },
    };
    return request(requestParams);
  };

  bindVehicle = ({
    cockpitNumber,
    vehicleNameList,
  }: {
    cockpitNumber: string;
    vehicleNameList: string[];
  }) => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/bindVehicle',
      method: Method.POST,
      body: { cockpitNumber, vehicleNameList },
    };
    return request(requestParams);
  };

  getCockpitBoardInfo = (cockpitTeamNumber: string): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpitTeam/getCockpitIssueStatistic',
      method: Method.POST,
      body: { cockpitTeamNumber },
    };
    return request(requestParams);
  };

  getVehicleList = (cockpitTeamNumber: string): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/k2/management/monitor/cockpit_team/get_position_list',
      method: Method.POST,
      body: { cockpitTeamNumber, level: 'vehicle' },
    };
    return request(requestParams);
  };
  quitCockpit = (): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/quitCockpit',
      method: Method.POST,
    };
    return request(requestParams);
  };

  switchStatus = (params: {
    acceptIssueStatus: AcceptIssueStatus;
    nextStatus?: CockpitStatus;
    cockpitNumber: string;
  }): Promise<any> => {
    const requestParams: RequestOptions = {
      path: '/monitor/web/cockpit/switchStatus',
      method: Method.POST,
      body: {
        cockpitNumber: params.cockpitNumber,
        cockpitStatus: params.nextStatus,
        acceptIssueStatus: params.acceptIssueStatus,
      },
    };
    return request(requestParams);
  };
}
